import { Column, Row } from "@components/Layout";
import { styled } from "solid-styled-components";

export const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
`;
export const OptionsWrapper = styled(Column)`
     ${({ theme }) => `
	background: ${theme?.colors.foreground};
	box-shadow: ${theme?.shadows.big};
  color: ${theme?.colors.color};
  `};
    border-radius: 15px;
    overflow: auto;
    max-height: calc(3.5 * 50px);
    width: 100%;
    position: absolute;
    top: 50px;
    z-index: 50;
`;

export const SelectItem = styled(Row)`
  min-height: 50px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  &:hover {
    background: ${({ theme }) => theme?.colors.accentQuinary};
  }
`;
